<template>
  <div class="d-flex">
    <!-- UNCOMMENT FOR IMAGE -->
    <!-- <div class="mr-3">
      <img
        class="resource-img"
        :src="resourceData.image"
        alt="Resource image"
      />
    </div> -->
    <div>
      <a :href="resourceData.url" @click="navigateToResource" :target="getResourceLinkTarget()">
        <h3 class="title">{{ resourceData.title }}</h3>
      </a>
      <div class="description">{{ resourceData.description }}</div>
    </div>
  </div>
</template>

<script>
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "resources-card",
  props: ["resourceData"],
  mixins: [HomebaseMixpanelMixin],
  data() {
    return {
      defaultImgUrl: "",
    };
  },
  computed: {
    imgUrl() {
      return this.resourceData && this.resourceData.image
        ? this.resourceData.image
        : this.defaultImgUrl;
    },
  },
  methods: {
    navigateToResource() {
      if (!this.resourceData.url) return;
      this.trackResource(`${this.resourceData.title} - ${this.resourceData.url}`);
    },

    getResourceLinkTarget() {
      return this.resourceData.newTab ? "_blank" : "_self";
    },
  },
};
</script>

<style scoped>
a {
  color: black !important;
  text-decoration: none !important;
}
.title:hover {
  cursor: pointer;
}
.resource-img {
  width: 80px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/resources/ResourcesCard.vue